import Uri from "jsuri";

const EnvNames = {
	DEV: "DEV",
	STAGE: "STAGE",
	PROD: "PROD",
	QA: "QA",
	UAT: "UAT",
};

const ConnectPortalUrls = {
	[EnvNames.DEV]: "https://connect.dev.redhat.com/",
	[EnvNames.QA]: "https://connect.qa.redhat.com/",
	[EnvNames.STAGE]: "https://connect.stage.redhat.com/",
	[EnvNames.PROD]: "https://connect.redhat.com/",
	[EnvNames.UAT]: "https://connect.uat.redhat.com/",
};

const RHCERTURLs = {
	[EnvNames.DEV]: "https://rhcert.connect.dev.redhat.com/",
	[EnvNames.QA]: "https://rhcert.connect.dev.redhat.com/",
	[EnvNames.STAGE]: "https://rhcert.connect.preprod.redhat.com/",
	[EnvNames.PROD]: "https://rhcert.connect.redhat.com/",
	[EnvNames.UAT]: "https://rhcert.connect.uat.redhat.com/",
};

const AccessRedhatPortals = {
	[EnvNames.DEV]: "https://access.qa.redhat.com/",
	[EnvNames.QA]: "https://access.qa.redhat.com/",
	[EnvNames.STAGE]: "https://access.stage.redhat.com/",
	[EnvNames.PROD]: "https://access.redhat.com/",
	[EnvNames.UAT]: "https://access.redhat.com/",
};

const DevelopersRedhatPortals = {
	[EnvNames.DEV]: "https://developers.qa.redhat.com/",
	[EnvNames.QA]: "https://developers.qa.redhat.com/",
	[EnvNames.STAGE]: "https://developers.stage.redhat.com/",
	[EnvNames.PROD]: "https://developers.redhat.com/",
	[EnvNames.UAT]: "https://developers.redhat.com/",
};

const CatalogPortals = {
	[EnvNames.DEV]: "https://catalog.qa.redhat.com/",
	[EnvNames.QA]: "https://catalog.qa.redhat.com/",
	[EnvNames.STAGE]: "https://catalog.stage.redhat.com/",
	[EnvNames.PROD]: "https://catalog.redhat.com/",
	[EnvNames.UAT]: "https://catalog.redhat.com/",
};

const ContentCenterPortals = {
	[EnvNames.DEV]: "https://content.stage.redhat.com/content/rhcc/us/en/homepage-internal.html",
	[EnvNames.QA]: "https://content.stage.redhat.com/content/rhcc/us/en/homepage-internal.html",
	[EnvNames.STAGE]: "https://content.stage.redhat.com/content/rhcc/us/en/homepage-internal.html",
	[EnvNames.PROD]: "https://content.redhat.com",
	[EnvNames.UAT]: "https://content.redhat.com",
};

const SSOPortalUrls = {
	[EnvNames.DEV]: "https://sso.stage.redhat.com/",
	[EnvNames.QA]: "https://sso.stage.redhat.com/",
	[EnvNames.STAGE]: "https://sso.stage.redhat.com/",
	[EnvNames.UAT]: "https://sso.stage.redhat.com/",
	[EnvNames.PROD]: "https://sso.redhat.com/",
};

const getEnvName = (): string => {
	const prodHostNames = [
		"connect.redhat.com",
		"prod.foo.redhat.com",
		"connect.uat.redhat.com",
		"prod.spaship--partner-connect.partner-connect.prod.apps.int.spoke.prod.us-west-2.aws.paas.redhat.com",
	];
	const qaHostNames = [
		"stage.foo.redhat.com",
		"connect.qa.redhat.com",
		"qa.foo.redhat.com",
		"preprod.spaship--partner-connect.partner-connect.qa.apps.int.spoke.preprod.us-east-1.aws.paas.redhat.com",
	];
	const stageHostNames = [
		"connect.stage.redhat.com",
		"stage-connect.redhat.com",
		"preprod.spaship--partner-connect.partner-connect.stage.apps.int.spoke.preprod.us-east-1.aws.paas.redhat.com",
	];
	const uatHostNames = [
		"prod.spaship--partner-connect.partner-connect.uat.apps.int.spoke.prod.us-west-2.aws.paas.redhat.com",
	];
	if (prodHostNames.indexOf(window.location.hostname) !== -1) return EnvNames.PROD;
	if (uatHostNames.indexOf(window.location.hostname) !== -1) return EnvNames.UAT;
	if (stageHostNames.indexOf(window.location.hostname) !== -1) return EnvNames.STAGE;
	if (qaHostNames.indexOf(window.location.hostname) !== -1) return EnvNames.QA;
	return EnvNames.DEV;
};

const getHydraAPIUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://connect.qa.redhat.com");
			case EnvNames.QA:
				return new Uri("https://connect.qa.redhat.com");
			case EnvNames.STAGE:
				return new Uri("https://connect.stage.redhat.com");
			case EnvNames.UAT:
				return new Uri("https://connect.uat.redhat.com");
			case EnvNames.PROD:
				return new Uri("https://connect.redhat.com");
			default:
				return new Uri("https://connect.qa.redhat.com");
		}
	}
	return new Uri("https://connect.qa.redhat.com");
};

const getPyxisGraphqlAPIUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
			case EnvNames.QA:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
			case EnvNames.STAGE:
				return new Uri("https://catalog.stage.redhat.com/api/containers/graphql/");
			case EnvNames.UAT:
				return new Uri("https://catalog.uat.redhat.com/api/containers/graphql/");
			case EnvNames.PROD:
				return new Uri("https://catalog.redhat.com/api/containers/graphql/");
			default:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
		}
	}
	return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
};

export default class Env {
	static getEnvName = getEnvName;
	static EnvNames = EnvNames;
	static ConnectPortalUrls = ConnectPortalUrls;
	static RHCERTURLs = RHCERTURLs;
	static AccessRedhatPortals = AccessRedhatPortals;
	static DevelopersRedhatPortals = DevelopersRedhatPortals;
	static CatalogPortals = CatalogPortals;
	static ContentCenterPortals = ContentCenterPortals;
	static SSOPortal = SSOPortalUrls;
	static hydraAPIURL = getHydraAPIUrl();
	static hydraAPIPrefix = "/hydra/prm/v1";
	static pfsPSPrefix = "/pfs/ps";
	static pyxisGraphqlAPIURL = getPyxisGraphqlAPIUrl();
	static routePrefix = "/partner-portal";
}
